<template lang="pug">
#modal-vetorial
    el-dialog(
        title='Informar arquivo vetorial do laudo',
        width='500px',
        top='5vh',
        :visible='show',
        @close='closeDialog'
    )
        p.mb-1 {{ $t('mensagens.laudos.solicitante') }}: {{ rowInfo.usuarioSolicitacaoNome }}
        p.mb-1 Pessoa: {{ rowInfo.informacaoLaudo.nomeRepresentante }}

        hr

        h4.font-weight-bold.py-3 Upload de arquivo vetorial kml
        el-upload.upload-demo(
            action='#',
            drag,
            :file-list='fileList',
            :limit='1',
            :on-exceed='handleExceed',
            :auto-upload='false',
            :on-change='onLoadFile',
            :on-remove='onRemoveFile',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100(v-if='rowInfo.informacaoLaudo') Arraste o arquivo aqui ou <em>clique para subir</em>

        .d-flex.flex-direction.justify-content-between.py-3
            BaseButton(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
            BaseButton(
                slot='footer',
                size='mini',
                type='primary',
                @click='inserirArquivo'
            ) {{ $t('mensagens.comuns.finalizar') }}
</template>

<script>
import LaudosService from '@/services/LaudosService';
import L from 'leaflet';
import geometryConverter from '@/utils/conversorGeometrias';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalInsercaoArquivoVetorial',

    components: {
        BaseButton
    },

    emits: ['update:show', 'update:lista'],

    props: {
        show: {
            type: Boolean,
            required: true
        },
        rowInfo: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            arquivo: null,
            geometria: null,
            geometrias: [],
            arquivoUpload: null,
            fileList: []
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show');
        },

        async inserirArquivo() {
            if (!this.arquivoUpload) {
                this.$notify.error({
                    message: 'Upload do arquivo é obrigatório.'
                });
                return;
            }

            const laudoGeometria = {
                idLaudo: this.rowInfo.id,
                geoJson: this.geometrias[0]
            };

            try {
                await LaudosService.atualizarGeometria(laudoGeometria);

                this.$notify.success({
                    message: 'Informação vetorial adicionada com sucesso!'
                });

                this.closeDialog();

                setTimeout(this.atualizarTabela, 2000);
            } catch (e) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.ocorreuUmErroAoAdicionarArquivo')
                });
            }
        },

        handleExceed() {
            this.$notify.warning(this.$t('mensagens.laudos.limiteDeUmArquivo'));
        },

        atualizarTabela() {
            this.$emit('update:lista');
        },

        async onLoadFile(file, fileList) {
            const arq = { nomeArquivo: 'vetorial', uid: file.uid };
            this.arquivoUpload = arq;

            let reader = new FileReader();

            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                geometryConverter
                    .read(extension, e.target.result, file.raw)
                    .then(geometria => {
                        this.processarGeometria(geometria);

                        this.geometria = geometria;
                    })
                    .catch(rejectReason => {
                        this.clearFields();
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        processarGeometria(geometria) {
            this.filtrarGeometrias(geometria);
            if (geometria !== null && geometria.getLayers().length > 0) {
                if (
                    geometria.getLayers()[0].feature.geometry.type ===
                    'GeometryCollection'
                ) {
                    _.each(geometria.getLayers()[0].getLayers(), layer =>
                        this.processarLayer(layer)
                    );
                } else {
                    _.each(geometria.getLayers(), layer =>
                        this.processarLayer(layer)
                    );
                }
            } else {
                this.clearFields();

                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.arquivoNaoPossuiGeometriaValida')
                });
            }
        },

        filtrarGeometrias(layerGeometrias) {
            if (layerGeometrias === null) return;

            if (layerGeometrias.getLayers) {
                layerGeometrias.getLayers().forEach(layer => {
                    if (!(layer instanceof L.Polygon)) {
                        if (layer instanceof L.LayerGroup) {
                            return this.filtrarGeometrias(layer);
                        }
                        layerGeometrias.removeLayer(layer);
                    }
                });
            } else {
                if (!(layerGeometrias instanceof L.Polygon)) {
                    return L.featureGroup();
                }
            }
        },

        processarLayer(layer) {
            this.geometrias.push(layer.toGeoJSON().geometry);
        },

        onRemoveFile(file, fileList) {
            this.clearFields();
        },

        clearFields() {
            this.arquivoUpload = null;
            this.fileList = [];
            this.geometria = null;
            this.geometrias = [];
        }
    }
};
</script>

<style lang="scss">
#modal-vetorial {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }
}
</style>
